import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default class SilverstoneAnim {
	constructor(next, type) {
		this.type = type;
		this.section = next.container;
		this.bgkColor = this.section.dataset.color;
		this.bodyClasses = next.html.match(/<body.+?class="([^""]*)"/i);

		// Intro elements
		this.intro = this.section.querySelector('.intro');
		this.description = this.intro.querySelector('.description');
		this.title = this.intro.querySelector('.main-title');
		this.introCaption = this.intro.querySelector('.caption');
		this.backBtn = this.intro.querySelector('.back-btn');
		this.header = document.querySelector('.main-navbar');

		// Gallery elements
		this.gallery = this.section.querySelector('.gallery');
		this.thumbs = [...this.gallery.querySelectorAll('.thumb')];
		this.focusThumb = this.gallery.querySelector('.focus');
		this.galleryCaption = this.gallery.querySelector('.caption');
		this.activeLayer = this.focusThumb.querySelector('.img-a');
		this.inactiveLayer = this.focusThumb.querySelector('.img-b');
		this.footer = document.querySelector('.main-footer');

		this.currentThumb = null;
	}

	// === INTRO ===

	init() {
		window.scrollTo(0, 0);
		gsap.set([this.description, this.title, this.introCaption], { autoAlpha: 0 });

		document.fonts.ready.then(() => {
			this.descSplit = SplitText.create(this.description, { type: "lines", autoSplit: true, mask: "lines", aria: "none" });
			this.titleSplit = SplitText.create(this.title, { type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			this.tl = gsap.timeline({
				defaults: { ease: 'expo.out', force3D: true },
				onComplete: () => {
					this.descSplit.revert();
					this.titleSplit.revert();
					this.initClick();
				}
			});

			if (this.type !== 'self') {
				this.tl
					.to(document.body, { backgroundColor: this.bgkColor, duration: 1 }, 0)
					.add(() => {
						document.body.setAttribute('class', (this.bodyClasses && this.bodyClasses.at(1)) ?? '');
						gsap.set(document.body, {clearProps: 'all'});
					}, '>')
				}

			this.tl
				.to(this.header, {y: 0, duration: 1}, 0)
				.set(this.description, { autoAlpha: 1 }, 0)
				.from(this.descSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.2, stagger: 0.08}, 0)
				.set(this.title, { autoAlpha: 1 }, '<20%')
				.from(this.titleSplit.lines, { yPercent: 80, autoAlpha: 0, duration: 1.3}, '<')
				.to(this.introCaption, { autoAlpha: 1, duration: 1.0, ease: 'power2.out' }, '<20%')
				.to(this.thumbs, {autoAlpha: 1, duration: 1, stagger: 0.05, ease: 'power3.inOut'}, 0)
				.to([this.focusThumb, this.galleryCaption], {autoAlpha: 1, duration: 1, ease: 'power3.inOut'}, 0.2)
				.to(this.backBtn, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, 0.3);

				if (!this.header.classList.contains('is-fixed') && !this.header.classList.contains('top')) {

					this.tl
						.set(this.header, {clearProps: 'all'}, 0)
						.add(() => {
							this.header.classList.add('top');
						}, 0)
				}
		});
	}

	leave(toNamespace) {

		this.tl = gsap.timeline({
			defaults: { force3D: true },
		});

		if (toNamespace === 'home') {
			window.headerInstance.backToHome();
			this.tl.to(this.footer, {opacity: 0, duration: 1}, 0.3)
		}

		this.tl
			.to(this.backBtn, { opacity: 0, y: -8, duration: 0.3, ease: 'power2.in' }, 0)
			.to([this.description, this.title, this.introCaption], {
				yPercent: -20,
				autoAlpha: 0,
				duration: 0.6,
				stagger: 0.05,
				ease: 'power2.inOut'
			}, 0)
			.to(this.gallery, {
				autoAlpha: 0,
				duration: 0.5,
				ease: 'power2.inOut'
			}, 0.3)

			return this.tl;
	}

	initClick() {
		const focusTop = this.focusThumb.getBoundingClientRect().top + window.scrollY - 100;

		this.thumbs.forEach(thumb => {
			thumb.addEventListener('click', () => {
				window.scrollTo({ top: focusTop, behavior: 'smooth' });

				if (this.currentThumb === thumb) return;
				this.currentThumb = thumb;

				const src = thumb.dataset.big;
				const alt = thumb.dataset.alt;

				// Crossfade focus image
				this.inactiveLayer.src = src;
				this.inactiveLayer.alt = alt;
				gsap.to(this.inactiveLayer, { autoAlpha: 1, duration: 0.65, ease: 'power2.inOut' });
				gsap.to(this.activeLayer, { autoAlpha: 0, duration: 0.65, ease: 'power2.inOut' });
				[this.activeLayer, this.inactiveLayer] = [this.inactiveLayer, this.activeLayer];

				// Dimmed/selected states
				this.thumbs.forEach(t => {
					if (t === thumb) {
						t.classList.remove('dimmed');
						t.classList.add('selected');
					} else {
						t.classList.remove('selected');
						t.classList.add('dimmed');
					}
				});
			});
		});
	}
}